"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositCipVerificationNextStep = void 0;
// Granular next-step enum — the caller reads this to decide routing
var DepositCipVerificationNextStep;
(function (DepositCipVerificationNextStep) {
    DepositCipVerificationNextStep["cipPassed"] = "cipPassed";
    DepositCipVerificationNextStep["cipFailed"] = "cipFailed";
    DepositCipVerificationNextStep["fraudReview"] = "fraudReview";
    DepositCipVerificationNextStep["needsPersona"] = "needsPersona";
    DepositCipVerificationNextStep["personaPassed"] = "personaPassed";
    DepositCipVerificationNextStep["personaFailed"] = "personaFailed";
    DepositCipVerificationNextStep["needsDocumentaryVerification"] = "needsDocumentaryVerification";
    DepositCipVerificationNextStep["approved"] = "approved";
    DepositCipVerificationNextStep["error"] = "error";
})(DepositCipVerificationNextStep || (exports.DepositCipVerificationNextStep = DepositCipVerificationNextStep = {}));
